import React, { useEffect, useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useProfessions } from '../../../../hooks/useProfessions';
import { FocusOption } from './CategoryPicker';

interface Props {
  value: FocusOption | null;
  onChange: (value: FocusOption | null) => void;
}

// Top-level profession picker for the read-only overview net.
export const ProfessionPicker: React.FC<Props> = ({ value, onChange }) => {
  const { professionsList, getProfessions, areProfessionsLoaded } = useProfessions();

  useEffect(() => {
    if (!areProfessionsLoaded) getProfessions();
  }, [areProfessionsLoaded, getProfessions]);

  const options = useMemo<FocusOption[]>(
    () =>
      [...(professionsList || [])]
        .map((p: { id: number; name: string }) => ({ id: p.id, name: p.name }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [professionsList],
  );

  return (
    <Autocomplete
      value={value ? (options.find((o) => o.id === value.id) ?? null) : null}
      onChange={(_, v) => onChange(v)}
      options={options}
      getOptionLabel={(o) => o.name || ''}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      renderInput={(params) => (
        <TextField {...params} label="Profession" placeholder="Search…" size="small" />
      )}
      sx={{ width: '100%' }}
    />
  );
};
